import { AlertCircle, ArrowLeft } from "@untitledui/icons";
import { useTranslation } from "react-i18next";

import { useAuth } from "@/hooks/useAuth";

const NoAccessPage = () => {
  const { t } = useTranslation();
  const { logout } = useAuth();

  const handleReturnToLogin = () => {
    logout();
  };

  return (
    <div
      className="flex min-h-screen items-center justify-center bg-gray-50 px-6"
      role="alert"
      aria-labelledby="no-access-title"
      aria-describedby="no-access-description"
    >
      <div className="w-full max-w-md text-center">
        {/* Icon */}
        <div
          className="mx-auto flex h-12 w-12 items-center justify-center rounded-xl bg-orange-100"
          aria-hidden="true"
        >
          <AlertCircle className="h-6 w-6 text-[var(--color-brand)]" aria-hidden="true" />
        </div>

        {/* Title */}
        <h1 id="no-access-title" className="mt-6 text-xl font-semibold text-[var(--color-brand)]">
          {t("noAccess.title")}
        </h1>

        {/* Description */}
        <p id="no-access-description" className="mt-2 text-sm leading-6 text-gray-600">
          {t("noAccess.description")}
        </p>

        {/* Button */}
        <button
          onClick={handleReturnToLogin}
          aria-label={t("noAccess.returnToLoginAria")}
          className="mt-8 inline-flex items-center justify-center gap-2 rounded-md 
            bg-[var(--color-brand)] px-4 py-2.5 text-sm font-semibold text-white 
            shadow-sm hover:opacity-90 
            focus:outline-none focus:ring-2 focus:ring-[var(--color-brand)] focus:ring-offset-2"
        >
          <ArrowLeft className="h-4 w-4" aria-hidden="true" />
          {t("noAccess.returnToLogin")}
        </button>
      </div>
    </div>
  );
};

export default NoAccessPage;
